// config/AppVersion.js
export const appVersion = 'v1.1.28'; // Versão do aplicativo